import { useState } from 'react';

import { ArrowUpward, ArrowDownward, AddCircleOutlined, DeleteForever } from '@mui/icons-material';
import { Box, Button, Container, CssBaseline, FormControl, IconButton, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";

import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../app/store';

import { addPalette, updateName, addColor, deleteColor, updateColor, addProduct, updateProduct, removeProduct, moveProductUp, moveProductDown } from './paletteSlice';

import ColorSelector from "../../Color/Color";
import { PaletteInformation } from '../../types/palette';

function Palettes() {
    const palettes = useSelector((state: RootState) => state.palettes.palettes);
    const dispatch: AppDispatch = useDispatch();

    const [paletteId, setPaletteId] = useState("");

    let palette: PaletteInformation = {
        name: '',
        id: '',
        colors: [],
        products: []
    };
    for (let p of palettes) {
        if (paletteId === '') break;
        if (p.id === paletteId) {
            palette = p;
            break;
        }
    }
    if (palette.id === '' && palettes.length > 0) {
        setPaletteId(palettes[0].id)
    }

    return(
        <Container>
            <CssBaseline></CssBaseline>
            <Box sx={{width:'100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <FormControl sx={{minWidth: 160}}>
                    <InputLabel>Palette</InputLabel>
                    <Select
                        id="palette-colors"
                        label='Palette'
                        variant='filled'
                        value={paletteId}
                        onChange={(event) => setPaletteId(event.target.value)}
                    >
                        {
                            palettes.map((p) => {
                                return (
                                    <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </FormControl>
                <Button sx={{float: 'right'}} variant='contained' onClick={() => dispatch(addPalette())}>
                    Create a new Palette
                </Button>
            </Box>
            {
                (paletteId === "") ?
                <></> :
                <>
                    <Box sx={{width: '100%', my: 2, display: 'flex', alignItems: 'center'}}>
                        <Typography variant='h6'>Palette Name:</Typography>
                        <TextField sx={{mx: 2}} value={palette.name} onChange={(event) => dispatch(updateName({paletteId: palette.id, name: event.target.value}))}></TextField>
                    </Box>
                    <Box sx={{width: '100%', my: 2}}>
                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                            <Typography variant='h6'>Colors</Typography>
                            <IconButton sx={{mx:2}} onClick={() => dispatch(addColor({paletteId: palette.id}))}>
                                <AddCircleOutlined/>
                            </IconButton>
                        </Box>
                        <Box sx={{width: '100%', my:2}}>
                            {palette.colors.map((c, idx) => {
                                return (
                                    <Box key={idx} sx={{mx: 1, my: 1, display: 'flex', alignItems: 'center'}}>
                                        <ColorSelector color={c} onChange={(color) => {
                                            dispatch(updateColor({paletteId: palette.id, color: color.hex, idx: idx}))
                                        }}></ColorSelector>
                                        <IconButton sx={{mx: 2}} onClick={() => dispatch(deleteColor({paletteId: palette.id, idx: idx}))}>
                                            <DeleteForever/>
                                        </IconButton>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                    <Box sx={{width: '100%', my: 2}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                            <Typography variant='h6'>Products</Typography>
                            <IconButton sx={{mx:2}} onClick={() => dispatch(addProduct({paletteId: palette.id}))}>
                                <AddCircleOutlined/>
                            </IconButton>
                        </Box>
                        <Box sx={{width: '100%', my:2}}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Image Source</TableCell>
                                            <TableCell>Image Preview</TableCell>
                                            <TableCell>Lower Price</TableCell>
                                            <TableCell>Upper Price</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            palette.products.map((product, idx) => {
                                                return (
                                                    <TableRow key={product.id}>
                                                        <TableCell><TextField sx={{minWidth: '200px'}} value={product.name} onChange={(event) => {
                                                            dispatch(updateProduct({
                                                                paletteId: palette.id,
                                                                idx: idx,
                                                                key: 'name',
                                                                value: event.target.value,
                                                            }))
                                                        }}></TextField ></TableCell>
                                                        <TableCell><TextField sx={{minWidth: '200px'}} multiline maxRows={4} value={product.description} onChange={(event) => {
                                                            dispatch(updateProduct({
                                                                paletteId: palette.id,
                                                                idx: idx,
                                                                key: 'description',
                                                                value: event.target.value,
                                                            }))
                                                        }}></TextField ></TableCell>
                                                        <TableCell><TextField sx={{minWidth: '200px'}} value={product.imgSrc} onChange={(event) => {
                                                            dispatch(updateProduct({
                                                                paletteId: palette.id,
                                                                idx: idx,
                                                                key: 'imgSrc',
                                                                value: event.target.value,
                                                            }))
                                                        }}></TextField></TableCell>
                                                        <TableCell><img alt={product.name} src={product.imgSrc}/></TableCell>
                                                        {/* maybe use regex to validate these fields? */}
                                                        <TableCell><TextField error={product.lowerPrice > product.upperPrice} sx={{width: '100px'}} value={product.lowerPrice}
                                                            onKeyDown={(event: any) => {
                                                                if (event.key === 'Backspace') {
                                                                  return;
                                                                }
                                                                if (event.key === '.' && !event.target.value.includes('.')) {
                                                                    return;
                                                                }
                                                                if (isNaN(Number(event.key))) {
                                                                  event.preventDefault()
                                                                }
                                                            }}
                                                            onBlur={(event) => {
                                                                event.target.value = Number(event.target.value).toFixed(2);
                                                                dispatch(updateProduct({
                                                                    paletteId: palette.id,
                                                                    idx: idx,
                                                                    key: 'lowerPrice',
                                                                    value: event.target.value,
                                                                }))
                                                            }}
                                                            onChange={(event) => {
                                                            dispatch(updateProduct({
                                                                paletteId: palette.id,
                                                                idx: idx,
                                                                key: 'lowerPrice',
                                                                value: event.target.value,
                                                            }))
                                                        }}/></TableCell>
                                                        <TableCell><TextField error={product.lowerPrice > product.upperPrice} sx={{width: '100px'}} value={product.upperPrice}
                                                            onKeyDown={(event: any) => {
                                                                if (event.key === 'Backspace') {
                                                                  return;
                                                                }
                                                                if (event.key === '.' && !event.target.value.includes('.')) {
                                                                    return;
                                                                }
                                                                if (isNaN(Number(event.key))) {
                                                                  event.preventDefault()
                                                                }
                                                            }}
                                                            onBlur={(event) => {
                                                                event.target.value = Number(event.target.value).toFixed(2);
                                                                dispatch(updateProduct({
                                                                    paletteId: palette.id,
                                                                    idx: idx,
                                                                    key: 'upperPrice',
                                                                    value: event.target.value,
                                                                }))
                                                            }}
                                                            onChange={(event) => {
                                                            dispatch(updateProduct({
                                                                paletteId: palette.id,
                                                                idx: idx,
                                                                key: 'upperPrice',
                                                                value: event.target.value,
                                                            }))
                                                        }}/></TableCell>
                                                        <TableCell>
                                                            <Box sx={{display: 'flex'}}>
                                                                <IconButton onClick={() => dispatch(removeProduct({paletteId: palette.id, idx: idx}))}><DeleteForever/></IconButton>
                                                                <Box>
                                                                    <IconButton sx={{display: idx === 0 ? 'none' : ''}} onClick={() => dispatch(moveProductUp({paletteId: palette.id, idx: idx}))}><ArrowUpward/></IconButton>
                                                                    <IconButton sx={{display: idx === (palette.products.length - 1) ? 'none' : ''}} onClick={() => dispatch(moveProductDown({paletteId: palette.id, idx: idx}))}><ArrowDownward/></IconButton>
                                                                </Box>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                        {/* <TableRow>
                                            <TableCell><TextField value={"Large Bouquet"} onChange={(event) => {}}></TextField></TableCell>
                                            <TableCell><TextField value={"img_src"} onChange={(event) => {}}></TextField></TableCell>
                                            <TableCell><img src={""}/></TableCell>
                                            <TableCell><IconButton><DeleteForever/></IconButton></TableCell>
                                        </TableRow> */}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </>
            }
        </Container>
    )
}

export default Palettes;